import styled from 'styled-components';
import {devices} from '../../../../utils/styledComponentHelpers';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 1001;
`;

export const ModalContentWrapper = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1002;
  background-color: white;
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow-y: auto; /* Enable scrolling for content */
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : $width || 'auto')};
  height: ${({ $height }) => (typeof $height === 'number' ? `${$height}px` : $height || 'auto')};
  max-width: ${({ $maxWidth }) => (typeof $maxWidth === 'number' ? `${$maxWidth}px` : $maxWidth || 'auto')};
  max-height: ${({ $maxHeight }) => (typeof $maxHeight === 'number' ? `${$maxHeight}px` : $maxHeight || 'auto')};
  ${devices.mobile} {
    width: ${({ $mobileWidth }) => (typeof $mobileWidth === 'number' ? `${$mobileWidth}px` : $mobileWidth || 'auto')};
    height: ${({ $mobileHeight }) => (typeof $mobileHeight === 'number' ? `${$mobileHeight}px` : $mobileHeight || 'auto')};
    max-width: ${({ $maxWidthMobile }) => (typeof $maxWidthMobile === 'number' ? `${$maxWidthMobile}px` : $maxWidthMobile || 'auto')};
    max-height: ${({ $maxHeightMobile }) => (typeof $maxHeightMobile === 'number' ? `${$maxHeightMobile}px` : $maxHeightMobile || 'auto')};
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  z-index: 1003;
`;